// src/base64/index.ts
var stringToBase64 = (str) => {
  return window.btoa(encodeURIComponent(str));
};
var base64ToString = (base64) => {
  try {
    return decodeURIComponent(window.atob(base64));
  } catch (error) {
    return "";
  }
};

export {
  stringToBase64,
  base64ToString
};
//# sourceMappingURL=chunk-ZMSCA5HP.mjs.map